module.exports = __webpack_public_path__ + "static/media/illustrate-6.612d655c.svg";